import { Helmet } from 'react-helmet';
import AddBank from '../../components/banks/AddBank';

const AddBankPage = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Add Bank Account - Global Triumph Market Plus Multiconcept</title>
        <meta
          name="description"
          content="User password editing page on Global Triumph Market Plus Multiconcept - Real estate investments and properties, properties for sales"
        />
      </Helmet>
      <div className="profile">
        <h1 className="pageTitle">Add Bank Account Details</h1>
        <h3 className="subtitle">You can add a new bank account details here</h3>
        <AddBank />
      </div>
    </>
  );
};

export default AddBankPage;
